import { NotifyHelper } from "../../../helpers/toast";
import { eDotTaoDeActionsObj } from "../../action-types/de-thi/IDotTaoDeActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const dotTaoDeActions = {
  ...generateActions(eDotTaoDeActionsObj, "DOT_TAO_DE"),
  ...generateActionForKey(
    eDotTaoDeActionsObj,
    "DOT_TAO_DE",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eDotTaoDeActionsObj,
    "DOT_TAO_DE",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDotTaoDeActionsObj,
    "DOT_TAO_DE",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDotTaoDeActionsObj,
    "DOT_TAO_DE",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDotTaoDeActionsObj,
    "DOT_TAO_DE",
    "DELETE_MULTIPLE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDotTaoDeActionsObj,
    "DOT_TAO_DE",
    "DELETE_MULTIPLE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDotTaoDeActionsObj,
    "DOT_TAO_DE",
    "CREATE_DETHI_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDotTaoDeActionsObj,
    "DOT_TAO_DE",
    "CREATE_DETHI_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
